import { pbxSettingsEn } from './en'

export const pbxSettingsEnCa = pbxSettingsEn
